<template>
  <div class="reg-stepper">
    <div
      v-for="(s, i) in steps" :key="i"
      class="reg-stepper-item"
      :class="{ done: current > s.num, active: current === s.num }"
    >
      <div class="reg-stepper-circle">
        <svg v-if="current > s.num" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.5">
          <path d="M20 6 9 17l-5-5"/>
        </svg>
      </div>
      <div class="reg-stepper-label">
        <span class="reg-stepper-num">{{ s.num }}º passo</span>
        <span class="reg-stepper-name">{{ s.name }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RegStepper",
  props: {
    steps:   { type: Array,  required: true },
    current: { type: Number, default: 1 },
  },
};
</script>

<style scoped lang="scss">
.reg-stepper {
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-self: flex-end;
  margin-bottom: 8px;
}
.reg-stepper-item {
  display: flex;
  align-items: center;
  gap: 10px;
  opacity: 0.4;
  transition: opacity 0.2s;
  &.active, &.done { opacity: 1; }
}
.reg-stepper-circle {
  width: 24px; height: 24px;
  border-radius: 50%;
  border: 2px solid rgba(255,255,255,0.4);
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
  color: #fff;
  transition: all 0.2s;
  .reg-stepper-item.active & { border-color: #ff825d; background: #ff825d; }
  .reg-stepper-item.done &   { border-color: #ff825d; background: #ff825d; }
}
.reg-stepper-label  { display: flex; flex-direction: column; }
.reg-stepper-num    { font-size: 11px; color: rgba(255,255,255,0.55); }
.reg-stepper-name   { font-size: 13px; font-weight: 600; color: #fff; }
</style>
